import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { RESIZE_URL } from 'utils/restapi';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import MobileAppLinkEditForm
  from 'components/dashboard/mobile-app-links/MobileAppLinkEditForm';
import MobileAppDeleteIcon
  from 'components/dashboard/mobile-app-links/MobileAppDeleteIcon';
import MobileAppLinkPublishedCheckbox
  from 'components/dashboard/mobile-app-links/MobileAppLinkPublishedCheckbox';

import './MobileAppLinkItemMob.css';

const MobileAppLinkItemMob = props => {
  const { item, patchMobileAppsLinkSuccess } = props;
  const { t } = useTranslation();
  const [showActions, setShowActions] = useState(false);

  return (
    <div className="mobile-app-link-item-mob__component">
      <div
        className={`mobile-app-link-item-wrapper
        ${(patchMobileAppsLinkSuccess && patchMobileAppsLinkSuccess.id === item.id) ?
          ' pulse' : ''}`}
      >
        <div className="main-block">
          <div className="swap-icon-container">
            <CommonSwapIcon />
          </div>

          <div className="info-container">
            {!showActions &&
              <div className="image-name">
                <div
                  className={`app-image ${item.app_type}`}
                  style={{ backgroundImage: item.thumbnail &&
                      `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=96/${item.thumbnail})` }}
                />
                <div className="name-label">
                  <div className="app-name">
                    {item.name}
                  </div>
                  <div className="link-label">
                    <div className={`icon ${item.app_type}`} />
                    <div className="label">{item.app_type === 'ios' ? 'iOS' : 'Android'} {t("App")}</div>
                  </div>
                </div>
              </div>
            }

            {showActions &&
              <Fragment>
                <MobileAppLinkEditForm
                  mobile
                  item={item}
                />
                <div className="actions-block">
                  <MobileAppLinkPublishedCheckbox
                    linkId={item.id}
                    isPublished={item.is_published}
                  />
                  <div className="delete-icon-mobile">
                    <MobileAppDeleteIcon linkId={item.id} />
                  </div>
                </div>
              </Fragment>
            }
          </div>
        </div>

        <div
          className="arrow-block"
          onClick={() => setShowActions(!showActions)}
          role="button"
          tabIndex={-1}
        >
          {/*<div className={`arrow-icon${showActions ? ' up' : ' down'}`} />*/}
          {showActions ? t("Back") : t("Customize App Link")}
        </div>
      </div>
    </div>
  );
};

MobileAppLinkItemMob.propTypes = {
  item: PropTypes.object.isRequired,
  patchMobileAppsLinkSuccess: PropTypes.object,
};

MobileAppLinkItemMob.defaultProps = {
  patchMobileAppsLinkSuccess: null,
};

export default MobileAppLinkItemMob;
